
const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-line-chart-line',
      title: '投資コンサルティング',
      description: 'お客様の投資目標とリスク許容度に基づいた、パーソナライズされた投資戦略を提案します。',
      features: ['ポートフォリオ分析', 'リスク評価', '投資戦略立案', '定期的な見直し']
    },
    {
      icon: 'ri-shield-check-line',
      title: '資産管理サービス',
      description: '包括的な資産管理により、お客様の財産を効率的に運用し、長期的な成長を実現します。',
      features: ['資産配分最適化', '税務効率化', 'リバランシング', 'パフォーマンス報告']
    },
    {
      icon: 'ri-bank-line',
      title: 'ウェルスマネジメント',
      description: '富裕層向けの総合的な財産管理サービスで、世代を超えた資産継承をサポートします。',
      features: ['相続対策', '事業承継', '不動産投資', 'プライベートバンキング']
    },
    {
      icon: 'ri-pie-chart-line',
      title: '退職金プランニング',
      description: '安心できる老後生活のための退職金運用プランを、ライフステージに合わせて設計します。',
      features: ['年金プランニング', 'iDeCo・NISA活用', 'ライフプラン設計', '医療・介護費用対策']
    },
    {
      icon: 'ri-global-line',
      title: '国際投資サービス',
      description: 'グローバルな投資機会を活用し、分散投資によるリスク軽減と収益機会の拡大を図ります。',
      features: ['海外株式・債券', '外国為替', '新興市場投資', 'ESG投資']
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '金融教育プログラム',
      description: 'お客様の金融リテラシー向上を支援し、より良い投資判断ができるようサポートします。',
      features: ['投資セミナー', '個別相談', 'マーケット分析', '投資レポート']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            私たちの<span className="text-blue-600">サービス</span>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            お客様一人ひとりのニーズに合わせた包括的な金融サービスを提供し、
            あなたの財務目標達成を全力でサポートします
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors">
                <i className={`${service.icon} text-2xl text-blue-600 group-hover:text-white transition-colors`}></i>
              </div>
              
              <h4 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h4>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              
              <div className="mt-6 pt-6 border-t border-gray-200">
                <a 
                  href="#contact" 
                  className="text-blue-600 hover:text-blue-700 font-medium flex items-center gap-2 group-hover:gap-3 transition-all"
                >
                  詳細を見る
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
